var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M473.885,88.279H38.115C17.045,88.403,0,105.517,0,126.617v129.385h512V126.617 C512,105.517,494.955,88.403,473.885,88.279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#82AFFF"
    },
    d: "M0,385.376c0,21.177,17.167,38.345,38.345,38.345h435.31c21.177,0,38.345-17.167,38.345-38.345 V256.003H0V385.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M256.82,327.983c-1.495-0.065-36.791-1.87-54.505-26.14c-10.324-14.142-12.384-32.952-6.123-55.907 l2.529,0.69c-6.038,22.143-4.12,40.195,5.704,53.662c16.958,23.249,52.154,25.06,52.51,25.075L256.82,327.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M196.167,235.758c-1.74,4.533-1.343,9.28,0.672,12.878c3.906-1.325,7.377-4.587,9.118-9.12 c1.74-4.533,1.343-9.28-0.672-12.878C201.378,227.965,197.907,231.225,196.167,235.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M218.275,298.426c-1.932,3.187-2.439,7.46-1.007,11.608c1.336,3.876,4.094,6.735,7.29,8.178 c-3.105-1.628-7.054-2.035-10.93-0.698c-4.148,1.43-7.2,4.463-8.52,7.948c3.187,1.931,7.459,2.439,11.608,1.007 c4.148-1.43,7.2-4.463,8.52-7.948l-0.004-0.002c1.916-3.183,2.418-7.439,0.992-11.573 C224.793,302.798,221.761,299.746,218.275,298.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M210.717,286.858c-2.98,2.237-5.044,6.013-5.263,10.395c-0.205,4.095,1.288,7.776,3.715,10.306 c-2.275-2.668-5.788-4.519-9.88-4.724c-4.382-0.22-8.345,1.457-10.869,4.199c2.237,2.98,6.013,5.044,10.394,5.263 s8.345-1.457,10.869-4.199c-0.001-0.001-0.002-0.002-0.002-0.002c2.963-2.241,5.015-6.003,5.235-10.37 C215.135,293.345,213.459,289.382,210.717,286.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M207.448,273.816c-3.604,0.947-6.941,3.665-8.797,7.639c-1.736,3.715-1.742,7.687-0.449,10.946 c-1.1-3.329-3.654-6.369-7.368-8.104c-3.976-1.857-8.278-1.801-11.649-0.214c0.947,3.604,3.665,6.941,7.639,8.797 c3.976,1.857,8.278,1.801,11.649,0.214c0,0-0.001-0.003-0.002-0.004c3.591-0.956,6.911-3.665,8.761-7.626 C209.091,281.491,209.036,277.188,207.448,273.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M209.302,260.875c-3.709-0.369-7.783,1.017-10.908,4.096c-2.921,2.878-4.312,6.599-4.235,10.104 c0.129-3.503-1.206-7.243-4.083-10.163c-3.08-3.126-7.132-4.572-10.845-4.259c-0.369,3.709,1.016,7.782,4.096,10.908 c3.08,3.126,7.132,4.572,10.845,4.259c0,0,0-0.003,0-0.006c3.699,0.355,7.755-1.026,10.87-4.095 C208.169,268.641,209.615,264.588,209.302,260.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M211.924,248.557c-3.596-0.978-7.843-0.285-11.435,2.234c-3.357,2.355-5.344,5.794-5.848,9.265 c0.707-3.434,0.009-7.342-2.344-10.698c-2.519-3.592-6.276-5.689-9.991-5.995c-0.978,3.596-0.285,7.843,2.234,11.435 c2.519,3.592,6.276,5.689,9.991,5.995c0-0.002,0-0.003,0-0.003c3.588,0.961,7.818,0.269,11.398-2.242 C209.521,256.028,211.618,252.27,211.924,248.557z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 212.97,
    cy: 316.51,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 225.52,
    cy: 318.05,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 205.76,
    cy: 295.87,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 188.39,
    cy: 275.33,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 200.52,
    cy: 261.43,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 195.92,
    cy: 247.17,
    r: 2.731
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M256.932,327.983l-0.115-2.622c0.355-0.013,35.552-1.826,52.51-25.075 c9.824-13.465,11.742-31.519,5.704-53.662l2.529-0.69c6.26,22.955,4.2,41.766-6.123,55.907 C293.724,326.113,258.428,327.918,256.932,327.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M317.586,235.758c1.74,4.533,1.343,9.28-0.672,12.878c-3.906-1.325-7.377-4.587-9.118-9.12 c-1.74-4.533-1.343-9.28,0.672-12.878C312.374,227.965,315.845,231.225,317.586,235.758z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M295.476,298.426c1.932,3.187,2.439,7.46,1.007,11.608c-1.336,3.876-4.094,6.735-7.29,8.178 c3.105-1.628,7.054-2.035,10.93-0.698c4.148,1.43,7.2,4.463,8.52,7.948c-3.187,1.931-7.459,2.439-11.608,1.007 c-4.148-1.43-7.2-4.463-8.52-7.948c0.001-0.001,0.003-0.001,0.003-0.001c-1.913-3.185-2.415-7.441-0.99-11.574 C288.958,302.798,291.991,299.746,295.476,298.426z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M303.036,286.858c2.98,2.237,5.044,6.013,5.263,10.395c0.205,4.095-1.288,7.776-3.715,10.306 c2.275-2.668,5.788-4.519,9.88-4.724c4.382-0.22,8.345,1.457,10.869,4.199c-2.237,2.98-6.013,5.044-10.395,5.263 s-8.345-1.457-10.869-4.199c0.001-0.001,0.002-0.002,0.002-0.002c-2.963-2.241-5.016-6.003-5.235-10.37 C298.617,293.345,300.294,289.382,303.036,286.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M306.304,273.816c3.604,0.947,6.941,3.665,8.797,7.639c1.736,3.715,1.742,7.687,0.449,10.946 c1.1-3.329,3.654-6.369,7.368-8.104c3.976-1.857,8.278-1.801,11.649-0.214c-0.947,3.604-3.665,6.941-7.639,8.797 c-3.976,1.857-8.278,1.801-11.649,0.214c0,0,0.001-0.003,0.002-0.004c-3.591-0.956-6.911-3.665-8.761-7.626 C304.66,281.491,304.716,277.188,306.304,273.816z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M304.45,260.875c3.709-0.369,7.783,1.017,10.908,4.096c2.921,2.878,4.312,6.599,4.235,10.104 c-0.129-3.503,1.206-7.243,4.083-10.163c3.08-3.126,7.132-4.572,10.845-4.259c0.369,3.709-1.016,7.782-4.096,10.908 c-3.08,3.126-7.132,4.572-10.845,4.259c0,0,0-0.003,0-0.006c-3.699,0.355-7.755-1.026-10.87-4.095 C305.583,268.641,304.137,264.588,304.45,260.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41AA5A"
    },
    d: "M301.828,248.557c3.596-0.978,7.843-0.285,11.435,2.234c3.357,2.355,5.344,5.794,5.848,9.265 c-0.707-3.434-0.009-7.342,2.344-10.698c2.519-3.592,6.276-5.689,9.991-5.995c0.978,3.596,0.285,7.843-2.234,11.435 c-2.519,3.592-6.276,5.689-9.991,5.995c0-0.002,0-0.003,0-0.003c-3.588,0.961-7.818,0.269-11.398-2.242 C304.231,256.028,302.134,252.27,301.828,248.557z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 300.79,
    cy: 316.51,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 288.22,
    cy: 318.05,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 307.99,
    cy: 295.87,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 325.36,
    cy: 275.33,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 313.24,
    cy: 261.43,
    r: 2.731
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 317.84,
    cy: 247.17,
    r: 2.731
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8CD7FF"
    },
    d: "M272.247,236.246h-31.325c-9.751,0-17.655,7.904-17.655,17.655v27.595 c0,9.752,7.904,17.655,17.655,17.655h31.325c9.75,0,17.655-7.903,17.655-17.655v-27.595 C289.902,244.15,281.998,236.246,272.247,236.246z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "261.753,260.263 261.753,263.757 258.259,263.757 258.259,260.263 255.567,260.263  255.567,263.757 252.072,263.757 252.072,260.263 249.886,260.263 249.886,267.253 251.634,269.466 251.634,295.215  262.119,295.215 262.119,269.466 263.866,267.253 263.866,260.263  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.386,249.194c1.729-0.838,2.185,2.695,2.185,2.695c3.641-1.821,2.691-4.776,1.821-6.189 c-1.165-1.894-5.825-2.622-7.791,1.311s3.35,11.724,3.35,11.724C257.24,256.33,255.128,250.286,257.386,249.194z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "279.722,266.78 279.722,270.275 276.226,270.275 276.226,266.78 273.535,266.78  273.535,270.275 270.039,270.275 270.039,266.78 267.853,266.78 267.853,273.77 269.601,275.983 269.601,301.732 280.087,301.732  280.087,275.983 281.834,273.77 281.834,266.78  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M275.353,255.711c1.729-0.838,2.185,2.695,2.185,2.695c3.641-1.821,2.691-4.776,1.821-6.189 c-1.165-1.894-5.825-2.622-7.791,1.311c-1.966,3.933,3.35,11.724,3.35,11.724C275.208,262.848,273.097,256.804,275.353,255.711z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "243.786,266.78 243.786,270.275 240.29,270.275 240.29,266.78 237.599,266.78  237.599,270.275 234.104,270.275 234.104,266.78 231.917,266.78 231.917,273.77 233.665,275.983 233.665,301.732 244.151,301.732  244.151,275.983 245.899,273.77 245.899,266.78  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M239.417,255.711c1.729-0.838,2.185,2.695,2.185,2.695c3.641-1.821,2.691-4.776,1.821-6.189 c-1.165-1.894-5.825-2.622-7.791,1.311c-1.966,3.933,3.35,11.724,3.35,11.724C239.273,262.848,237.161,256.804,239.417,255.711z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6EC86E"
    },
    d: "M285.554,297.079c-2.334-1.154-4.926-1.864-7.706-1.864c-2.979,0-5.741,0.815-8.196,2.13 c-3.191-3.439-7.713-5.625-12.776-5.625s-9.583,2.186-12.776,5.625c-2.455-1.315-5.217-2.13-8.196-2.13 c-2.781,0-5.373,0.71-7.706,1.864c4.99,9.152,14.546,23.941,28.678,29.593C271.008,321.02,280.564,306.231,285.554,297.079z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256.718,179.949l0.158-0.078C256.876,179.871,256.823,179.885,256.718,179.949z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M256.876,179.871l0.158,0.078C256.928,179.885,256.876,179.871,256.876,179.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M290.409,194.835c-0.983-5.679-8.301-6.663-16.712-7.209c-8.41-0.546-12.015-5.352-12.015-5.352 h-9.612c0,0-3.605,4.806-12.015,5.352s-15.729,1.529-16.712,7.209c-0.983,5.679,6.226,14.636,6.226,14.636l6.335-5.133 c0,0-7.755-7.427-3.933-10.158c3.775-2.697,14.782-0.829,19.684-7.303c-0.207,1.353-0.135,3.023,0.704,5.081 c1.602,3.933,1.02,8.884,1.02,8.884h3.496h3.496c0,0-0.583-4.952,1.02-8.884c0.839-2.058,0.913-3.729,0.704-5.081 c4.903,6.474,15.91,4.606,19.684,7.303c3.823,2.731-3.933,10.158-3.933,10.158l6.335,5.133 C284.183,209.472,291.392,200.515,290.409,194.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M260.444,162.613h-1.821v-1.966c0-0.966-0.782-1.748-1.748-1.748s-1.748,0.782-1.748,1.748v1.966 h-1.894c-0.966,0-1.748,0.782-1.748,1.748s0.782,1.748,1.748,1.748h1.894v5.024c0,0.966,0.782,1.748,1.748,1.748 s1.748-0.782,1.748-1.748v-5.024h1.821c0.966,0,1.748-0.782,1.748-1.748C262.191,163.395,261.409,162.613,260.444,162.613z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFF0E1"
    },
    cx: 256.87,
    cy: 172.88,
    r: 3.496
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M231.827,243.223c1.408,0.703,3.052,1.311,4.733,1.311c5.791,0,8.629-3.275,8.629-9.066 s-3.494-10.158-9.284-10.158c0,0-0.653,0.011-1.699,0.171c-0.225,0.036-0.448,0.07-0.668,0.12 c-5.567,1.062-19.325,6.191-22.1,31.166c-3.879,34.912,24.467,66.41,45.439,73.4v-3.496 C256.876,326.673,207.36,288.808,231.827,243.223z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC75A"
    },
    points: "235.904,228.804 256.876,235.796 235.904,242.786  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFE15A"
    },
    points: "277.847,242.786 256.876,235.796 277.847,228.804  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M214.911,257.153c2.504-22.538,14.317-27.172,19.406-28.145c0.111-0.025,0.225-0.042,0.417-0.073 c0.64-0.098,1.081-0.125,1.219-0.131c3.832,0.026,6.359,2.913,6.359,6.408c0,3.854-2.258,5.315-4.514,5.388 c0,0,1.821-3.787-1.894-4.806c-2.506-0.689-5.679,1.311-5.388,4.951c0.205,2.559,2.634,5.024,5.388,5.024 c5.791,0,10.486-4.185,10.486-9.976s-4.695-10.486-10.486-10.486c0,0-0.653,0.011-1.699,0.171c-0.225,0.036-0.448,0.07-0.668,0.12 c-5.567,1.062-19.325,6.191-22.1,31.166c-3.879,34.912,24.467,66.41,45.439,73.4v-3.496c0,0-7.427-3.714-12.505-7.321 C228.682,308.205,212.079,282.644,214.911,257.153z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M281.926,243.223c-1.408,0.703-3.052,1.311-4.733,1.311c-5.791,0-8.629-3.275-8.629-9.066 s3.494-10.158,9.284-10.158c0,0,0.653,0.011,1.699,0.171c0.225,0.036,0.448,0.07,0.668,0.12c5.567,1.062,19.325,6.191,22.1,31.166 c3.879,34.912-24.467,66.41-45.439,73.4v-3.496C256.876,326.673,306.392,288.808,281.926,243.223z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC75A"
    },
    points: "277.847,228.804 256.876,235.796 277.847,242.786  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M298.84,257.153c-2.504-22.538-14.317-27.172-19.406-28.145c-0.111-0.025-0.225-0.042-0.417-0.073 c-0.64-0.098-1.081-0.125-1.219-0.131c-3.832,0.026-6.359,2.913-6.359,6.408c0,3.854,2.258,5.315,4.514,5.388 c0,0-1.821-3.787,1.894-4.806c2.506-0.689,5.679,1.311,5.388,4.951c-0.205,2.559-2.634,5.024-5.388,5.024 c-5.791,0-10.486-4.185-10.486-9.976s4.695-10.486,10.486-10.486c0,0,0.653,0.011,1.699,0.171c0.225,0.036,0.448,0.07,0.668,0.12 c5.567,1.062,19.325,6.191,22.1,31.166c3.879,34.912-24.467,66.41-45.439,73.4v-3.496c0,0,7.427-3.714,12.505-7.321 C285.07,308.205,301.673,282.644,298.84,257.153z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFE15A"
    },
    cx: 256.87,
    cy: 235.8,
    r: 3.496
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M281.834,207.724c0.928-2.403-0.328-5.625-0.328-5.625c-3.222-0.109-5.461,2.239-5.461,2.239 c0.273-2.894-0.983-5.516-0.983-5.516c-4.151,0.491-5.516,2.95-5.516,2.95c-0.218-4.533-2.95-6.39-2.95-6.39 c-3.605,1.092-4.696,5.024-4.696,5.024c-0.546-4.478-5.024-6.553-5.024-6.553s-4.478,2.076-5.024,6.553c0,0-1.092-3.933-4.696-5.024 c0,0-2.731,1.857-2.95,6.39c0,0-1.365-2.457-5.516-2.95c0,0-1.256,2.622-0.983,5.516c0,0-2.239-2.348-5.461-2.239 c0,0-1.256,3.222-0.328,5.625c0,0-3.659-1.146-6.663,0.6c0,0,5.506,2.13,7.341,4.751h48.561c1.834-2.622,7.341-4.751,7.341-4.751 C285.494,206.578,281.834,207.724,281.834,207.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M281.156,213.076c0,1.572-3.674,6.434-3.674,6.434s-11.914,1.658-20.606,1.658 c-8.748,0-20.689-1.704-20.689-1.704s-3.592-4.835-3.592-6.39c0-4.47,10.871-8.094,24.28-8.094 C270.285,204.981,281.156,208.606,281.156,213.076z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFC75A"
    },
    cx: 256.87,
    cy: 218.32,
    rx: 20.977,
    ry: 6.99
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC75A"
    },
    d: "M262.009,179.543c0-2.294-1.711-5.207-5.133-3.168c-3.423-2.039-5.133,0.874-5.133,3.168 s-2.622,2.622-2.95,2.403c0,0,2.185,2.84,4.696,0.983c0,0,1.347,1.966,3.386,1.966c2.039,0,3.387-1.966,3.387-1.966 c2.513,1.857,4.696-0.983,4.696-0.983C264.631,182.165,262.009,181.837,262.009,179.543z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M249.884,348.954c-0.196,0-0.396-0.044-0.584-0.14c-0.649-0.321-0.911-1.109-0.587-1.758 l6.99-13.981c0.324-0.642,1.111-0.911,1.758-0.584c0.649,0.321,0.911,1.109,0.587,1.758l-6.99,13.981 C250.827,348.689,250.365,348.954,249.884,348.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B46446"
    },
    d: "M263.869,348.954c-0.481,0-0.943-0.266-1.174-0.724l-6.99-13.981 c-0.324-0.649-0.062-1.437,0.587-1.758c0.646-0.331,1.433-0.062,1.758,0.584l6.99,13.981c0.324,0.649,0.062,1.437-0.587,1.758 C264.264,348.91,264.065,348.954,263.869,348.954z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M288.333,336.722c-20.716,4.631-42.199,4.631-62.915,0c0-3.496,0-10.038,0-13.533 c20.716,4.631,42.199,4.631,62.915,0C288.333,326.684,288.333,333.226,288.333,336.722z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M242.749,331.626c-13.377,2.581-27.086,3.289-40.727,2.015c0.23,1.802,11.017,7.158,11.017,7.158 s-9.518,4.6-9.306,6.266c13.058,1.22,26.183,0.638,39.016-1.677V331.626L242.749,331.626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M271.054,331.626c13.377,2.581,27.086,3.289,40.727,2.015c-0.23,1.802-11.017,7.158-11.017,7.158 s9.518,4.6,9.306,6.266c-13.058,1.22-26.183,0.638-39.016-1.677V331.626L271.054,331.626z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm);
export default __webpack_public_path__ + "static/media/sm.6e388a911d0df92ef7717f6a458e7b0f.svg";
export { ForwardRef as ReactComponent };